/* eslint-disable react/jsx-closing-bracket-location */
import React, {Fragment, PureComponent} from 'react';
import {connect} from 'react-redux';
import {Field, Fields, formValueSelector, SubmissionError, reduxForm} from 'redux-form';
import {times, pick} from 'lodash';
import {FormattedMessage, injectIntl} from 'react-intl';
import {ButtonPrimary, Button} from '@homeaway/react-buttons';
import {LoadingOverlayWrapper} from '@homeaway/react-loading-overlay';
import GenericError from '../GenericError/GenericError';
import formSubmit from '../../../utils/formSubmit';
import TelephoneNumber from '../TelephoneNumber/TelephoneNumber';
import EmailInput from '../EmailInput/EmailInput';
import NameInput from '../NameInput/NameInput';
import ReservationNumberInput from '../ReservationNumberInput/ReservationNumberInput';
import GiftCardInformation from '../GiftCardInformation/GiftCardInformation';
import {getReduxFormError} from '../../../utils/validations';
import {
    FIRST_NAME_LABEL,
    LAST_NAME_LABEL,
    RESERVATION_INFORMATION_LABEL,
    RESERVATION_INFORMATION_LABEL_TEXT,
    GIFT_CARD_COUNT_LIMIT,
    CONTACT_INFORMATION_TEXT,
    GIFT_CARD_ADD_TEXT,
    GIFT_CARD_SUBMIT_TEXT,
    GIFT_CARD_REDEMPTION_FORM,
    GIFT_CARD_SUBMIT_TEXT_ARIA,
    GIFT_CARD_SUBMIT_TEXT_ERROR_ARIA,
    BED_AND_BREAKFAST
} from '../../../utils/constants';
import GiftCardSubmitSuccess from '../GiftCardSubmitSuccess/GiftCardSubmitSuccess';

import './GiftCardForm.less';

const FIRST_NAME_LABEL_TEXT = (
    <FormattedMessage
        id="giftCardFirstNameText"
        defaultMessage={FIRST_NAME_LABEL}
    />
);

const LAST_NAME_LABEL_TEXT = (
    <FormattedMessage
        id="giftCardLastNameText"
        defaultMessage={LAST_NAME_LABEL}
    />
);

const CONTACT_INFORMATION_LABEL = (
    <FormattedMessage
        id="giftCardContactInfoText"
        defaultMessage={CONTACT_INFORMATION_TEXT}
    />
);

let GiftCard = class GiftCard extends PureComponent {
    state = {
        giftCardCount: 1,
        giftCardArr: [],
        giftCardErrors: []
    };

    isLoaderVisible = false;
    onAddGiftCard = () => {
        const {giftCardCount, giftCardArr} = this.state;
        if (giftCardCount < GIFT_CARD_COUNT_LIMIT) {
            this.setState({
                giftCardCount: giftCardCount + 1,
                giftCardArr: [...giftCardArr,
                    <Fields
                        key={giftCardCount}
                        giftCardErrors={this.state.giftCardErrors}
                        names={[`certificateNumber${giftCardCount}`, `orderId${giftCardCount}`, `giftCardImageUploader${giftCardCount}`]}
                        component={GiftCardInformation}
                        giftCardCount={giftCardCount}
                    />]
            });
        }
        return giftCardArr;
    };

    isAddGiftCardDisabled = () => {
        const props = this.props;
        for (let i = 0; i < this.state.giftCardCount; i++) {
            const orderId = props[`orderId${i}`];
            const certificateNumber = props[`certificateNumber${i}`];
            const giftCardImage = props[`giftCardImageUploader${i}`];
            if (!(orderId && certificateNumber && giftCardImage)) {
                return true;
            }
        }
        return false;
    };

    handleSubmitAction = (values) => {
        this.isLoaderVisible = true;
        const {giftCardCount} = this.state;
        const errorObj = getReduxFormError({values, giftCardCount});
        const isErrorKeyPresent = Object.keys(errorObj).length;
        const payloadFields = ['firstName', 'lastName', 'email', 'phone', 'reservationNumber', 'giftCards'];

        /* Filter image related errors */
        this.setState({
            giftCardErrors: Object.keys(errorObj).filter(
                (error) => error.indexOf('giftCardImageUploader') === 0
            )
        });

        if (isErrorKeyPresent) {
            this.isLoaderVisible = false;
            throw new SubmissionError(errorObj);
        }

        values.giftCards = times(giftCardCount, (index) => {
            return {
                id: index,
                orderId: values[`orderId${index}`],
                certificateNumber: values[`certificateNumber${index}`],
                giftCardImage: Object.values(values[`giftCardImageUploader${index}`])
            };
        });
        values = pick(values, payloadFields);
        return formSubmit(values);
    };

    render() {
        const {giftCardArr, giftCardCount} = this.state;
        const {handleSubmit, submitSucceeded, submitFailed, submitting, intl} = this.props;
        const FORM_SUBMIT_LABEL_ARIA = intl.formatMessage({
            id: 'giftCardSubmitTextAria',
            defaultMessage: GIFT_CARD_SUBMIT_TEXT_ARIA},
        {bnbbrandSite: BED_AND_BREAKFAST}
        );

        const FORM_SUBMIT_LABEL_ERROR_ARIA = intl.formatMessage({
            id: 'giftCardSubmitTextErrorAria',
            defaultMessage: GIFT_CARD_SUBMIT_TEXT_ERROR_ARIA
        });
        /* istanbul ignore next */
        const submitAria = (submitFailed && FORM_SUBMIT_LABEL_ERROR_ARIA) || FORM_SUBMIT_LABEL_ARIA;

        return (
            <Fragment>
                {!submitSucceeded && <form onSubmit={handleSubmit(this.handleSubmitAction)} className="GiftCard__Max_width GiftCardForm" >

                    <div className="GiftCard__Contact_information" aria-label={intl.formatMessage({
                        id: 'giftCardRedemptionForm',
                        defaultMessage: GIFT_CARD_REDEMPTION_FORM
                    })}
                    >
                        {/* istanbul ignore next */
                            this.isLoaderVisible && submitting && this.props.children}
                        <h3 className="GiftCard__Title">{CONTACT_INFORMATION_LABEL}</h3>
                        <div className="GiftCard__Fields_Wrapper">
                            <div className="GiftCard__Fields">
                                <Field
                                    name="firstName"
                                    component= {NameInput}
                                    label = {FIRST_NAME_LABEL_TEXT}
                                    id ="firstName"
                                />
                            </div>
                            <div className="GiftCard__Fields">
                                <Field
                                    name="lastName"
                                    component= {NameInput}
                                    label = {LAST_NAME_LABEL_TEXT}
                                    id ="lastName"
                                />
                            </div>
                        </div>
                        <div className="GiftCard__Fields_Wrapper GiftCard__Contact_Wrapper">
                            <div className="GiftCard__Fields">
                                <Field
                                    name="email"
                                    component= {EmailInput}
                                />
                            </div>
                            <div className="GiftCard__Fields">
                                <Field
                                    name="phone"
                                    component= {TelephoneNumber}
                                />
                            </div>
                        </div>
                        <h3 className="GiftCard__Title">{RESERVATION_INFORMATION_LABEL}</h3>
                        <div className="GiftCard__Fields_Wrapper">
                            <div className="GiftCard__Fields">
                                <Field
                                    name="reservationNumber"
                                    component= {ReservationNumberInput}
                                    label = {RESERVATION_INFORMATION_LABEL_TEXT}
                                    id ="reservationNumber"
                                />
                            </div>
                        </div>

                        <div>
                            <Fields
                                names={['certificateNumber0', 'orderId0', 'giftCardImageUploader0']}
                                component= {GiftCardInformation}
                                giftCardCount={0}
                                giftCardErrors={this.state.giftCardErrors}
                                key="0"
                            />
                        </div>
                        {giftCardArr}
                        {giftCardCount < GIFT_CARD_COUNT_LIMIT && <Button size="xs" className="AddGiftCard__Button" onClick={this.onAddGiftCard}
                            disabled={this.isAddGiftCardDisabled()}
                            label={intl.formatMessage({
                                id: 'giftCardAddMessage',
                                defaultMessage: GIFT_CARD_ADD_TEXT
                            })}
                        />
                        }
                        <Field
                            name="genericError"
                            component= {GenericError}
                        />
                        <ButtonPrimary aria-label = {submitAria} label = {intl.formatMessage({
                            id: 'giftCardSubmitText',
                            defaultMessage: GIFT_CARD_SUBMIT_TEXT
                        })} className="Button" type="submit" id="formSubmit"
                        />
                    </div>
                </form>}
                {/* istanbul ignore next */
                    submitSucceeded && <GiftCardSubmitSuccess />}
            </Fragment>
        );
    }
};

const mapStateToProps = (state) => {
    const selector = formValueSelector('giftCardForm');
    let stateObj = {};
    times(GIFT_CARD_COUNT_LIMIT, (index) => {
        stateObj = {
            ...stateObj,
            ...{[`orderId${index}`]: selector(state, `orderId${index}`)},
            ...{
                [`certificateNumber${index}`]: selector(
                    state,
                    `certificateNumber${index}`
                )
            },
            ...{
                [`giftCardImageUploader${index}`]: selector(
                    state,
                    `giftCardImageUploader${index}`
                )
            }
        };
    });
    return stateObj;
};

export default injectIntl(connect(mapStateToProps)(reduxForm({
    form: 'giftCardForm'
})(LoadingOverlayWrapper(GiftCard))));
